import { getSubscriptionHistoryApiV1BillingOrgIdBillingSubscriptionHistoryGet } from '@/common/api/client/sdk.gen'
import { useQuery } from '@tanstack/react-query'
import { useMemo } from 'react'
import { useSubscription } from './useSubscription'

export const useCurrentSubscriptionPeriod = (org_id: string | undefined) => {
    const {
        subscription,
        hasActiveSubscription,
        isLoading: isSubscriptionLoading,
        error,
        refetch,
    } = useSubscription(org_id)

    const { data: history, isLoading: isHistoryLoading } = useQuery({
        queryKey: ['subscription-history', org_id],
        queryFn: () =>
            org_id
                ? getSubscriptionHistoryApiV1BillingOrgIdBillingSubscriptionHistoryGet({
                      path: { org_id },
                      query: { page: 1, size: 10 },
                  }).then(response => response.data!)
                : Promise.reject('No org_id'),
        enabled: !!org_id && hasActiveSubscription,
    })

    const currentPeriod = useMemo(() => {
        if (!history?.items?.length) return null

        const now = Date.now()
        const activePeriod = history.items.find(item => new Date(item.expires_at).getTime() > now)
        return activePeriod ?? history.items[0] ?? null
    }, [history])

    return {
        subscription,
        currentPeriod,
        hasActiveSubscription,
        isLoading: isSubscriptionLoading || (hasActiveSubscription && isHistoryLoading),
        error,
        refetch,
    }
}
